export default __webpack_public_path__ + "static/media/2.158c8509.jpg";